import React, {Component} from 'react';
import Data from "./Data";
import $ from "jquery";
import axios from "axios";
import ModalEditStudent from "./ModalEditStudent";
import {FiEdit} from "react-icons/fi";
import {AiOutlineMessage} from "react-icons/ai";
import {AiOutlineDelete} from "react-icons/ai";
import {FaRegAddressCard} from "react-icons/fa";
import {GrClose} from "react-icons/gr";
import { Card, Grid, Text, Link, Modal, Input, Spacer } from "@nextui-org/react";

import { Navbar, Button, Avatar, Dropdown } from "@nextui-org/react";
import { useSnackbar } from 'notistack';
import { useState, useEffect } from "react";
import { Snackbar, Alert } from '@mui/material';

function StudentsList(props) {

    const [openMessage,setOpenMessage] = useState(false);
    const [message,setMessage] = useState('');
    const [messageStatus,setMessageStatus] = useState('info');
    const [editmodal,setEditModal] = useState(false);
    const [openEditModal,setOpenEditModal] = useState(false);
    const [openDeleteModal,setOpenDeleteModal] = useState(false);
    const [fields,setFields] = useState({
        name : props.products['name'],
        family : props.products['family'],
        phone : props.products['phone']
    });
    const [errors,setErrors] = useState({});
    
    const {enqueueSnackbar, closeSnackbar} = useSnackbar();

    useEffect(() => {
        let formIsValid = true;

        if (fields.name === props.products['name'] &&
            fields.family === props.products['family'] &&
            fields.phone === props.products['phone']){
            formIsValid = false;
            errors['no'] = 'لطفا یکی از فیلدها را تغییر دهید!';
        }else {
            errors['no'] = null;
        }
        if (fields.name === ""){
            formIsValid = false;
            errors['name'] = 'لطفا نام هنرجو را وارد کنید!';
        }else {
            errors['name'] = null;
        }
        if (fields.family === ""){
            formIsValid = false;
            errors['family'] = 'لطفا نام خانوادگی هنرجو را وارد کنید!';
        }else {
            errors['family'] = null;
        }

        if (fields.phone === ""){
            formIsValid = false;
            errors['phone'] = 'لطفا شماره تلفن هنرجو را وارد کنید!';
        }else if (!fields.phone.startsWith('09')){
            formIsValid = false;
            errors['phone'] = 'لطفا شماره تلفن را با فرمت 09xxxxxxxxx وارد کنید!';
        }else if (fields.phone.length < 11){
            formIsValid = false;
            errors['phone'] = 'لطفا شماره تلفن را کامل وارد کنید!';
        }else {
            errors['phone'] = null;
        }
        
        setErrors({
            ...errors
        });
        
    }, [fields]);

    useEffect(() => {
        if(openEditModal==false){
            setTimeout(() => {
                setEditModal(false);
            }, 500);
            setOpenMessage(false);
        }
    }, [openEditModal]);
    
    useEffect(() => {
        if(editmodal==true){
            setOpenEditModal(true);
        }
    }, [editmodal]);

    const handleDelete=()=>{

        editmodalClose();
        $('#waitspinner').modal('show');

        let token = localStorage.getItem('token');
        let data = new FormData();
        data.append('token', '');
        data.append('id', products['id']);
        axios.post(Data.server+`deleteStudent.php`,data)
            .then(response => {
                $('#waitspinner').modal('hide');

                if (response.data === 'ok') {
                    enqueueSnackbar("ویرایش با موفقیت انجام شد", {variant:'success'});
                    $('#'+studentid).remove();
                }
                if (response.data === 'wrong id') {
                    
                    enqueueSnackbar("خطا : شناسه هنرجو اشتباه است",{variant:"warning"});
                    
                }
                if (response.data.hasOwnProperty('no_item')) {
                    $('#no_item').removeClass('invisible');
                }
            })
            .catch(error => {
                console.log(error)
                enqueueSnackbar("خطا : شناسه هنرجو اشتباه است",{variant:"warning"});

            });

    }
    const handleMenu=(key)=> {
        if (key=='edit'){
            setEditModal(true);
        }
        if (key=='delete'){
            setOpenDeleteModal(true);
        }
        
        
        console.log(key+" clicked!")
    }
    const editmodalClose=()=>{
        setOpenEditModal(false);
        setOpenDeleteModal(false);

    }
    
    const handleChange=(event)=>{
        const target = event.target;
        setFields({
            ...fields,
            [target.name] : target.value
        });
    }
    
    const handleSubmit=(event)=>{


        handleValidation((valid)=>{
            if (valid){
                editmodalClose();
                handleRequest();
            } else {
                
                if (errors['no'] !== null ){
                    showMessage(errors['no'], 'error');
                }
                if (errors['name'] !== null ){
                    showMessage(errors['name'], 'error');
                }
                if (errors['family'] !== null ){
                    showMessage(errors['family'], 'error');
                }
                if (errors['phone'] !== null ){
                    showMessage(errors['phone'], 'error');
                }
            }
        })

    }

    const showMessage = (msg, status) => {
        setMessage(msg);
        setMessageStatus(status);
        setOpenMessage(true);
    }

    const handleValidation=(callback)=>{
        let formIsValid = true;
        console.log("handleValidation");

        if (fields.name === props.products['name'] &&
            fields.family === props.products['family'] &&
            fields.phone === props.products['phone']){
            formIsValid = false;
            errors['no'] = 'لطفا یکی از فیلدها را تغییر دهید!';
        }else {
            errors['no'] = null;
        }
        if (fields.name === ""){
            formIsValid = false;
            errors['name'] = 'لطفا نام هنرجو را وارد کنید!';
        }else {
            errors['name'] = null;
        }
        if (fields.family === ""){
            formIsValid = false;
            errors['family'] = 'لطفا نام خانوادگی هنرجو را وارد کنید!';
        }else {
            errors['family'] = null;
        }

        if (fields.phone === ""){
            formIsValid = false;
            errors['phone'] = 'لطفا شماره تلفن هنرجو را وارد کنید!';
        }else if (!fields.phone.startsWith('09')){
            formIsValid = false;
            errors['phone'] = 'لطفا شماره تلفن را با فرمت 09xxxxxxxxx وارد کنید!';
        }else if (fields.phone.length < 11){
            formIsValid = false;
            errors['phone'] = 'لطفا شماره تلفن را کامل وارد کنید!';
        }else {
            errors['phone'] = null;
        }
        
        setErrors({...errors});
        return callback(formIsValid);
        
    }

    const handleRequest=()=>{
        console.log("handleRequest");

        $('#waitspinner').modal('show');
        $('#progressTop').removeClass('invisible');
        $('#r_fab').addClass('invisible');

        const {name,family,phone} = fields;
        const oldname = props.products['name'];
        const oldfamily = props.products['family'];
        const oldphone = props.products['phone'];

        let data = new FormData();
        data.append('id',props.products['id']);
        data.append('name',name);
        data.append('family',family);
        data.append('phone',phone);
        data.append('oldname',oldname);
        data.append('oldfamily',oldfamily);
        data.append('oldphone',oldphone);

        axios.post(Data.server+'editStudent.php',data)
            .then(response=>{

                $('#waitspinner').modal('hide');
                $('#progressTop').addClass('invisible');

                if (response.data === "ok") {

                    enqueueSnackbar("ویرایش با موفقیت انجام شد", {variant:'success'});

                    props.products['name'] = name;
                    props.products['family'] = family;
                    props.products['phone'] = phone;
                    setFields({
                        name: name,
                        family: family,
                        phone: phone
                    });

                }
                if (response.data.includes("error update")){
                    enqueueSnackbar("خطای داخلی رخ داد", {variant:'error'});
                }

            })
            .catch(error=>{
                $('#progressTop').addClass('invisible');
                $('#r_fab').addClass('animate__animated animate__zoomIn');
                console.log(error);
            });
    }

    const action = (
        <div className='text-white' style={{alignItems: 'center', margin:'0px', padding:'0px'}}>
            <GrClose className='m-0 p-0' onClick={handleClose} />
        </div>
    );
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
    
        setOpenMessage(false);
    };

        const {products,index} = props;
        let studentid = 'student'+products['id'];
        let collapseid = 'studentmodal'+index;
        let deletemodalid = 'deletemodal'+index;
        

        return (
            
            <div className="col-12 col-md-6 col-lg-4 mb-4" id={studentid}>
                <Card className='text-right' isHoverable variant="bordered" css={{ p: "$6", mw: "400px" }}>
                    <Card.Header>
                        <div className='d-flex'>
                            <img className="circle-icon"
                                height="50px"
                                width="50px"
                                src={Data.mainserver+"icons/user.png"}/>
                            <div className='p-2'>
                                <h5 className="">{products['name']+' '+products['family']}</h5>
                                <h6 className='text-muted'>{products['phone']}</h6>
                            </div>

                            <Dropdown placement="bottom-right">
                                <Dropdown.Trigger>
                                    <i className='bx bx-dots-vertical-rounded'
                                        style={{position: 'absolute', left:'20px' , fontSize:'20px' , cursor:'pointer'}}
                                    ></i>
                                </Dropdown.Trigger>
                                <Dropdown.Menu
                                  aria-label="User menu actions"
                                  color="secondary"
                                  variant="solid"
                                  className='text-right'
                                  onAction={(actionKey) => handleMenu(actionKey)}
                                >
                                  
                                  <Dropdown.Item icon={<FiEdit className='mx-1' />} key="edit">
                                    ویریش
                                  </Dropdown.Item>
                                  <Dropdown.Item icon={<AiOutlineMessage className='mx-1'/>} key="sendsms">
                                    ارسال پیامک
                                  </Dropdown.Item>
                                  <Dropdown.Item icon={<FaRegAddressCard className='mx-1'/>} key="register">
                                    ثبت نام
                                  </Dropdown.Item>
                                  
                                  <Dropdown.Item icon={<AiOutlineDelete className='mx-1'/>} key="delete" withDivider color="error" >
                                    حذف
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                            
                        </div>
                    </Card.Header>
                    <Card.Divider />
                    <Card.Body className='text-right' css={{ py: "$2" }}>
                        <div className='text-left'>
                            <div className='text-muted text-small'>{products['online']}</div>
                        </div>
                    </Card.Body>
                </Card>
                <Modal
                    blur
                    closeButton
                    aria-labelledby='modal-title'
                    open={openDeleteModal}
                    onClose={editmodalClose}
                >

                    <Modal.Header>
                        <Text id='modal-title' size={18}>
                            حدف
                            <Text b size={18} css={{ tt: "capitalize" }}>
                                {" "+products['name']}
                            </Text>
                            <Text b size={17} css={{ tt: "capitalize" }}>
                                {" "+products['phone']}
                            </Text>
                            
                        </Text>
                    </Modal.Header>
                    <Modal.Body>
                    <Text id='modal-title' size={18}>
                        {"آیا از حدف "+products['name']+" مطمئن هستید ؟"}
                    </Text>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button auto flat color='error' onPress={editmodalClose}>
                            لغو
                        </Button>
                        <Button auto color='secondary' type='submit' onPress={handleDelete.bind(this)}>
                            حذف
                        </Button>
                    </Modal.Footer>
                </Modal>
                {editmodal?<Modal
                    closeButton
                    blur
                    aria-labelledby='modal-title'
                    open={openEditModal}
                    onClose={editmodalClose}
                >
                    
                    <Snackbar
                        open={openMessage}
                        autoHideDuration={3000}
                        onClose={handleClose}
                        action={action}>
                            <Alert onClose={handleClose} variant="filled" severity={messageStatus} sx={{ width: '100%' }}>
                                {message}
                            </Alert>
                    </Snackbar>

                    <Modal.Header>
                        <Text id='modal-title' size={18}>
                            ویرایش 
                            <Text b size={18}>
                                {' '+products['name']+' '+products['family']}
                            </Text>
                        </Text>
                    </Modal.Header>
                    <Modal.Body>
                        <Input
                            clearable
                            bordered
                            fullWidth
                            type="text"
                            name="name"
                            value={fields['name']}
                            
                            status={errors['name'] ?'error':'default'}
                            helperText={errors['name'] ?errors['name']:''}
                            onChange={handleChange}
                            size='lg'
                            placeholder='نام'
                        />
                        <Spacer y={0.1}/>
                        <Input
                            clearable
                            bordered
                            fullWidth
                            type="text"
                            name="family"
                            value={fields['family']}
                            
                            status={errors['family'] ?'error':'default'}
                            helperText={errors['family'] ?errors['family']:''}
                            onChange={handleChange}       
                            size='lg'
                            placeholder='نام خانوادگی'
                        />
                        <Spacer y={0.1}/>
                        <Input
                            clearable
                            bordered
                            fullWidth
                            onInput={(e) => {
                                e.target.value = e.target.value.toString().slice(0, 11)
                                e.target.value = e.target.value.replace(/\D/g, "")
                            }}
                            type="number"
                            name="phone"
                            value={fields['phone']}
                            
                            status={errors['phone'] ?'error':'default'}
                            helperText={errors['phone'] ?errors['phone']:''}
                            onChange={handleChange}
                            size='lg'
                            placeholder='شماره تلفن'
                        />
                        <Spacer y={0.1}/>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button auto flat color='error' onPress={editmodalClose}>
                            بستن
                        </Button>
                        <Button auto color='secondary' type='submit' onPress={handleSubmit.bind(this)}>
                            ویرایش
                        </Button>
                    </Modal.Footer>
                </Modal>:<div></div>}
                    

            </div>


        );
    
}


export default StudentsList;
